import './main.less';
import '../news-shared.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';
import cn from 'classname';

import LangSwitch from '../../../../shared/lang/switch';
import InputField from '../../../../shared/form-elements/input';
import TextField from '../../../../shared/form-elements/textarea';
import SelectField from '../../../../shared/form-elements/select/field';

const Main = props => {
	const { selectOptions, showForm, isShouldPublishChecked } = props.formData;
	const submit = data => props.formSubmit(data);
	return (
		showForm &&
		<div
			className={cn({
				'news-form-wrap': true,
				[props.className]: true
			})}
		>
			<div className="news-form-wrap__langs">
				<LangSwitch langs={props.formLangs} onChangeLang={() => {}} />
				<div className="small-form-controls">
					<button className="icon-close" onClick={() => props.hideForm()} />
					<Link to="/news/edit/" className="icon-fullscreen" />
				</div>
			</div>
			<form className="ui-form news-form__main clearfix" onSubmit={props.handleSubmit(submit)}>
				<div className="news-form__main-fields">
					<div className="news-group group-left">
						<div className="title-category-group">
							<div className="ui-form__element title">
								<Field name="title" placeholder={props.intl('Title')} component={InputField} />
							</div>

							<div className="ui-form__element category">
								<Field
									name="type"
									placeholder={props.intl('Category')}
									component={SelectField}
									searchable={false}
									multi={false}
									options={selectOptions['types']}
								/>
							</div>
						</div>

						<div className="ui-form__element offers">
							<Field
								name="news_offers"
								placeholder={props.intl('Offers')}
								component={SelectField}
								searchable={true}
								multi={true}
								options={props.offersLookups}
							/>
						</div>

						<div className="ui-form__element offers">
							<Field
								name="news_locations"
								placeholder={props.intl('Countries')}
								component={SelectField}
								searchable={true}
								multi={true}
								options={props.locationsLookup}
							/>
						</div>
					</div>

					<div className="news-group group-center">
						<div className="ui-form__element">
							<Field name="text" placeholder={props.intl('Text')} component={TextField} />
						</div>
					</div>

					<div className="news-group group-right">
						<div className="ui-form__element buttons-wrap">
							{props.can('edit') &&
								<button type="submit" className="ui-btn ui-btn-primary">
									{isShouldPublishChecked ? props.intl('Publish') : props.intl('Save')}
								</button>}
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};

Main.propTypes = {
	formLangs: PropTypes.array,
	formData: PropTypes.object,
	handleSubmit: PropTypes.func,
	formSubmit: PropTypes.func,
	offersLookups: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func
};

export default reduxForm({
	form: 'newsListForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/news/components/form/small/main.js